export const PersonaEnum = Object.freeze({
    CAREER: "CAREER",
    LETTER_WRITER: "LETTER_WRITER",
    RECRUIT: "RECRUIT",
    RECRUITER: "RECRUITER_ROOT",
    RECRUITER_COMMAND: "RECRUITER_COMMAND",
});
